<section class="home-banner spacing-header">
  <section class="ahm-section-border">
    <div class="finalise-quote padding-bottom-xxbig">
      <div class="grid grid-wrapper align-middle text-center-medium-down align-center-medium-down padding-top-medium">
        <div class="cell cell-large-col-span-6 cell-medium-col-span-8 padding-sides-medium">
          <div class="display-large text-surface-decorative-text padding-top-xxbig margin-top-xxbig"><span>Ready to hit<br></span><span>the road?</span></div>
          <div class="text-large text-blackMatte margin-vertical-medium">Let&apos;s finalise your quote to get you moving! You&apos;ll just need to confirm the details you&apos;ve provided are correct and answer some additional questions.</div>
          <button mat-flat-button color="primary" type="button" [routerLink]="['/quote/' + reference?.uuid]">Continue quote</button>
          <div class="text-large text-blackMatte margin-top-medium">Need help? <a href="https://ahm.com.au/contact-us" target="_blank" class="action-tertiary-link">Let's talk</a>.</div>
        </div>

        <div class="cell cell-large-col-start-7 cell-large-col-span-6 cell-medium-col-span-8 margin-top-xbig">
          <div product="home">
            <div class="block-price-details">
              <div class="show-for-medium-up block-marketing margin-top-xlarge">
                <img alt="ahm marketing" width="100%" height="100%" src="/assets/partners/ahm/images/ahm-marketing.png">
              </div>

              <div class="block-price-details padding-medium ahm-bg-black text-white text-left margin-bottom-small">
                <span class="text-white">{{quote?.human.vehicle.make}}</span>
                <h2 class="margin-bottom-xxsmall text-white">{{ quote?.covers[0].label }} from</h2>
                <p class="strong text-white margin-bottom-xxsmall" *ngIf="arrangementFeeBanner && quote.data.frequency === 'M'" [innerHTML]="arrangementFeeBanner.monthlyHeading"></p>
                <div class="row align-middle">
                  <div class="small-12 columns">
                    <div class="flex-container align-middle margin-bottom-xxsmall">
                      <open-price [dark]="true" [price]="price" [precision]="precision"></open-price>
                    </div>
                  </div>
                </div>
                <p class="strong text-white margin-bottom-xxsmall" *ngIf="arrangementFeeBanner" [innerHTML]="quote.data.frequency === 'M' ? arrangementFeeBanner.tag.monthly : arrangementFeeBanner.tag.annual"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <a id="product-information"></a>

  <div class="component-product-information">
    <div class="component-product-features">
      <section class="ahm-section-border">
        <div class="grid grid-wrapper padding-top-xxbig">
          <div class="cell cell-large-col-span-4 cell-medium-col-span-8 padding-bottom-xxbig">
            <open-svg-icon name="marketing-optionals" class="medium"></open-svg-icon>
            <h2 class="text-blackMatte margin-vertical-small">Insurance made easy</h2>
            <p class="text-darkGray margin-none ">Buy, manage and make claims online – you're in control. It's how insurance should be.</p>
          </div>
          <div class="cell cell-large-col-span-4 cell-medium-col-span-8 padding-bottom-xxbig">
            <open-svg-icon name="marketing-highestlimits" class="medium"></open-svg-icon>
            <h2 class="text-blackMatte margin-vertical-small">Back on the road, faster</h2>
            <p class="text-darkGray margin-none ">Submit a claim online 24/7. Our claims team will get the ball rolling so you get the help you need.</p>
          </div>
          <div class="cell cell-large-col-span-4 cell-medium-col-span-8 padding-bottom-xxbig">
            <open-svg-icon name="management-emergencyhelp" class="medium"></open-svg-icon>
            <h2 class="text-blackMatte margin-vertical-small">24/7 emergency help</h2>
            <p class="text-darkGray margin-none">Because accidents don't just happen from 9 to 5. Call us any time, we’re always here to help you stay safe.</p>
          </div>
        </div>
      </section>
    </div>

    <section class="ahm-section-border">
      <div class="grid grid-wrapper padding-vertical-xbig">
        <div class="cell cell-large-col-span-6 cell-medium-col-span-8 text-center-medium-down align-center-medium-down flex flex-row flex-items-center">
          <div>
            <h1 class="display-small text-surface-decorative-text flex-items-center padding-bottom-medium">Smart savings with<br>Pay As You Drive</h1>
            <p class="text-blackMatte">Save up to 30% on your premium if you drive 15,000km or less each year compared to our regular Comprehensive Cover.</p>

            <p class="text-blackMatte marghin-bottom-medium">Just pay for the distance you need and pocket the savings.</p>
          </div>
        </div>
        <div class="cell cell-large-col-span-6 cell-medium-col-start-2 cell-medium-col-span-6 text-center">
          <div class="show-for-medium-up margin-left-xbig margin-right-xbig">
            <lottie-player src="/assets/partners/ahm/animations/ahm-PAYD-partner-landing-page.json" background="transparent" autoplay loop></lottie-player>
          </div>
          <div class="show-for-small-down">
            <lottie-player src="/assets/partners/ahm/animations/ahm-PAYD-partner-landing-page.json" background="transparent" autoplay loop></lottie-player>
          </div>
          <p class="cell cell-large-col-span-6 margin-top-small">Example savings shown. Specific savings dependent on individual application.<br>Pay As You Drive only available for comprehensive car insurance</p>
        </div>
      </div>
    </section>


    <section class="section-cover-types ahm-section-border">
      <div class="extras-info padding-vertical-xxbig">
        <div class="grid grid-wrapper">
          <div class="cell cell-large-col-span-12 text-center margin-bottom-medium">
            <div class="display-small text-surface-decorative-text margin-top-none margin-bottom-medium">Choose your options</div>
            <p class="text-blackMatte"><span>Customise your Comprehensive Cover with the add-ons that suit you. Looking for Third Party Property Cover?&nbsp;</span><span><a (click)="showComparison()" class="action-tertiary-link">Compare our covers</a></span><span>.</span></p>
          </div>
        </div>
        <div class="grid grid-wrapper margin-bottom-small">
          <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-6 card-border padding-medium bg-white">
            <div class="card-small-view">
              <div class="padding-right-medium">
                <open-svg-icon name="options-hirecar" class="medium"></open-svg-icon>
              </div>
              <div>
                <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Hire car</h4>
                <p class="text-small text-darkGray margin-none">Cover for the cost of a hire car if we accept a claim for theft or damage, up to $70 a day for up to 14 days.</p>
              </div>
            </div>
          </div>
          <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-6 card-border padding-medium bg-white">
            <div class="card-small-view">
              <div class="padding-right-medium">
                <open-svg-icon name="options-excessfreewindscreen" class="medium"></open-svg-icon>
              </div>
              <div>
                <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Excess-free windscreen</h4>
                <p class="text-small text-darkGray margin-none">We'll repair or replace your front windscreen excess-free, once every 12 months.</p>
              </div>
            </div>
          </div>
          <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-6 card-border padding-medium bg-white">
            <div class="card-small-view">
              <div class="padding-right-medium">
                <open-svg-icon name="valuables-sportequipment" class="medium"></open-svg-icon>
              </div>
              <div class="padding-right-medium">
                <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Sports gear cover</h4>
                <p class="text-small text-darkGray margin-none">Up to $3,000 to cover your sports gear while it&apos;s in or on your car. Cover terms apply.</p>
              </div>
            </div>
          </div>
          <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-6 card-border padding-medium bg-white">
            <div class="card-small-view">
              <div class="padding-right-medium">
                <open-svg-icon name="options-kangacover" class="medium"></open-svg-icon>
              </div>
              <div>
                <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Kanga Cover</h4>
                <p class="text-small text-darkGray margin-none">Your first animal collision claim within a 12 month period is excess-free.</p>
              </div>
            </div>
          </div>
          <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-6 card-border padding-medium bg-white">
            <div class="card-small-view">
              <div class="padding-right-medium">
                <open-svg-icon name="options-roadassistance" class="medium"></open-svg-icon>
              </div>
              <div>
                <h4 class="text-blackMatte margin-bottom-xsmall margin-top-small">Roadside assistance</h4>
                <p class="text-small text-darkGray margin-none">Essential roadside assistance to help get you back on the road. This is a separate service provided by Allianz Global Assistance. Also available with Third Party Property Cover.<br><a [href]="apiEndpoint + roadsideTermsConditions?.url" target="_blank" class="action-tertiary-link">Read the Roadside Assistance T&amp;Cs.</a></p>
              </div>
            </div>
          </div>
        </div>
        <div class="grid grid-wrapper margin-top-medium">
          <div class="cell cell-large-col-span-12 cell-medium-col-span-8 cell-small-col-span-4">
            <div class="text-small spacing-right-small text-medium text-darkGray">
              <span>ahm insurance benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant </span>
              <span>&nbsp;<a [href]="apiEndpoint + pds?.url" target="_blank">Product Disclosure Statement (PDS)</a> and the <a [href]="apiEndpoint + tmd?.url" target="_blank">Target Market Determination (TMD)</a> which explains who the products are suitable for.</span>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section class="comp-cover-benefits ahm-section-border ahm-section-border-bottom">
      <div class="grid grid-wrapper padding-top-xxbig">
        <div class="cell cell-large-col-span-12 text-center">
          <div class="display-small text-surface-decorative-text margin-top-none margin-bottom-medium">Comprehensive cover stacked with benefits</div>
          <p class="text-blackMatte margin-bottom-xlarge margin-top-none"><span>These benefits come with our comprehensive policy. Looking for Third Party Property Cover?&nbsp;</span><span><a (click)="showComparison()" class="action-tertiary-link">Compare our covers</a></span><span>.</span></p>
        </div>
      </div>

      <div class="grid grid-wrapper align-center">
        <div class="cell cell-large-col-span-12">
          <div class="grid">
            <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-4 flex flex-column card-border">
              <div class="card-small-view">
                <div class="padding-top-icon-small">
                  <span class="show-for-medium-up"><open-svg-icon name="marketing-flexibleaccess" class="medium"></open-svg-icon></span>
                  <span class="show-for-small-down padding-right-small green-fill"><mat-icon class="check_circle"></mat-icon></span>
                </div>
                <div>
                  <h4 class="text-blackMatte margin-vertical-small">Flex-excess</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">You can choose to opt for a higher excess and reduce your premiums.</p>
                </div>
              </div>
            </div>

            <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-4 flex flex-column card-border">
              <div class="card-small-view">
                <div class="padding-top-icon-small">
                  <span class="show-for-medium-up"><open-svg-icon name="marketing-liability" class="medium"></open-svg-icon></span>
                  <span class="show-for-small-down padding-right-small green-fill"><mat-icon class="check_circle"></mat-icon></span>
                </div>
                <div>
                  <h4 class="text-blackMatte margin-vertical-small">Up to $20m liability cover</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">We'll repair or replace your front windscreen excess-free, once every 12 months.</p>
                </div>
              </div>
            </div>

            <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-4 flex flex-column card-border">
              <div class="card-small-view">
                <div class="padding-top-icon-small">
                  <span class="show-for-medium-up"><open-svg-icon name="management-emergencyhelp" class="medium"></open-svg-icon></span>
                  <span class="show-for-small-down padding-right-small green-fill"><mat-icon class="check_circle"></mat-icon></span>
                </div>
                <div>
                  <h4 class="text-blackMatte margin-vertical-small">24/7 emergency help</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">Call us any time. We&apos;re always here to help you stay safe and organise your car to be towed, no matter the time.</p>
                </div>
              </div>
            </div>

            <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-4 flex flex-column card-border">
              <div class="card-small-view">
                <div class="padding-top-icon-small">
                  <span class="show-for-medium-up"><open-svg-icon name="marketing-youarecovered" class="medium"></open-svg-icon></span>
                  <span class="show-for-small-down padding-right-small green-fill"><mat-icon class="check_circle"></mat-icon></span>
                </div>
                <div>
                  <h4 class="text-blackMatte margin-vertical-small">Additional Benefits</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">Cover for trailers, caravans, personal property, child safety seats and more.</p>
                </div>
              </div>
            </div>

            <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-6 flex flex-column card-border">
              <div class="card-small-view">
                <div class="padding-top-icon-small">
                  <span class="show-for-medium-up"><open-svg-icon name="car-comprehensive" class="medium"></open-svg-icon></span>
                  <span class="show-for-small-down padding-right-small green-fill"><mat-icon class="check_circle"></mat-icon></span>
                </div>
                <div>
                  <h4 class="text-blackMatte margin-vertical-small">Theft and damage cover</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">Cover for damage or loss caused by theft, attempted theft, collision, malicious damage, fire, and natural events.</p>
                </div>
              </div>
            </div>

            <div class="cell cell-large-col-span-4 cell-medium-col-span-4 cell-small-col-span-4 flex flex-column card-border">
              <div class="card-small-view">
                <div class="padding-top-icon-small">
                  <span class="show-for-medium-up"><open-svg-icon name="marketing-newforold" class="medium"></open-svg-icon></span>
                  <span class="show-for-small-down padding-right-small green-fill"><mat-icon class="check_circle"></mat-icon></span>
                </div>
                <div>
                  <h4 class="text-blackMatte margin-vertical-small">New for old car replacement</h4>
                  <p class="text-small text-darkGray margin-top-none margin-bottom-small flex-grow">We&apos;ll replace your car with a new car of the same value if it&apos;s under 2 years old, has been written off and you&apos;re the first registered owner or the car was a dealer demonstrator model when you bought it.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="grid grid-wrapper padding-bottom-big margin-top-xlarge">
        <div class="cell cell-large-col-span-12 cell-medium-col-span-8 cell-small-col-span-6">
          <div class="text-small text-darkGray">
            <span>ahm insurance benefits are subject to terms, limits and exclusions. For full details about our products, read the relevant <a [href]="apiEndpoint + pds?.url" target="_blank">Product Disclosure Statement (PDS)</a> and the <a [href]="apiEndpoint + tmd?.url" target="_blank">Target Market Determination (TMD)</a> which explains who the products are suitable for.</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Additional Charges Disclaimers -->
    <div class="grid grid-wrapper padding-bottom-small margin-top-xlarge">
      <div class="cell cell-large-col-span-12" *ngIf="quote.covers[0].has_additional_charges">
        <div class="text-small text-darkGray">
          <p *ngIf="quote.covers[0].additional_fees_disclaimer">* {{ quote.covers[0].additional_fees_disclaimer }}</p>
          <ul *ngIf="additionalChargesDisclaimers.length">
            <li *ngFor="let additionalCharges of additionalChargesDisclaimers"><strong>{{ additionalCharges.label }}:</strong> {{ additionalCharges.disclaimer }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

